import {REAL_MONEY} from 'app/utils/Consts';

export const isRealMoney = (type: string): boolean => type === REAL_MONEY;
